"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.widget = exports.AIForm = void 0;
var modules_1 = require("./modules");
var modules_2 = require("./modules");
Object.defineProperty(exports, "AIForm", { enumerable: true, get: function () { return modules_2.AIForm; } });
Object.defineProperty(exports, "widget", { enumerable: true, get: function () { return modules_2.widget; } });
if (process.env.NODE_ENV === "local") {
    modules_1.widget.init({ apiKey: "ADD_API_KEY" });
}
exports.default = {};
